// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.export-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.export-modal {
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 90%;
  max-width: 450px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.export-modal-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  text-align: center;
  color: #333;
}

.export-modal-options {
  margin-bottom: 20px;
}
.export-modal-options .export-modal-range {
  margin-left: 24px;
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
.export-modal-options .export-modal-range input[type=date] {
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.export-modal-options .export-modal-range span {
  align-self: center;
  font-weight: bold;
}

.export-modal-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}
.export-modal-option input {
  width: 16px;
  height: 16px;
  accent-color: var(--primary-color);
  margin-right: 8px;
}

.export-modal-desc {
  font-size: 14px;
  color: #666;
  margin-left: 24px;
  line-height: 1.4;
  margin-top: 8px;
  margin-bottom: 12px;
}

.export-modal-content-type {
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #f8f9fa;
}
.export-modal-content-type .content-type-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 12px;
  margin-top: 0;
}
.export-modal-content-type .content-type-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.export-modal-content-type .content-type-options .content-type-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}
.export-modal-content-type .content-type-options .content-type-option:hover {
  background-color: #e9ecef;
}
.export-modal-content-type .content-type-options .content-type-option input[type=radio] {
  margin: 0;
  cursor: pointer;
  accent-color: var(--primary-color);
}
.export-modal-content-type .content-type-options .content-type-option span {
  font-size: 13px;
  color: #4a5568;
  font-weight: 500;
  cursor: pointer;
}
.export-modal-content-type .content-type-options .content-type-option input[type=radio]:checked + span {
  color: #0a3d62;
  font-weight: 600;
}

.export-modal-orientation {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #f8f9fa;
}
.export-modal-orientation .orientation-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 12px;
  margin-top: 0;
}
.export-modal-orientation .orientation-options {
  display: flex;
  gap: 20px;
  align-items: center;
}
.export-modal-orientation .orientation-options .orientation-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}
.export-modal-orientation .orientation-options .orientation-option:hover {
  background-color: #e9ecef;
}
.export-modal-orientation .orientation-options .orientation-option input[type=radio] {
  margin: 0;
  cursor: pointer;
  accent-color: var(--primary-color);
}
.export-modal-orientation .orientation-options .orientation-option span {
  font-size: 13px;
  color: #4a5568;
  font-weight: 500;
  cursor: pointer;
}
.export-modal-orientation .orientation-options .orientation-option input[type=radio]:checked + span {
  color: #0a3d62;
  font-weight: 600;
}

.export-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 25px;
}
.export-modal-actions .btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.export-modal-actions .btn-cancel:hover {
  background-color: #f8f9fa;
}
.export-modal-actions .btn-export {
  padding: 8px 16px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.export-modal-actions .btn-export:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.export-modal-actions .btn-export:not(:disabled):hover {
  opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/components/ExportModal/ExportModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;AACE;EACE,iBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;AACJ;AACI;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;AACN;AAEI;EACE,kBAAA;EACA,iBAAA;AAAN;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAFF;AAIE;EACE,WAAA;EACA,YAAA;EACA,kCAAA;EACA,iBAAA;AAFJ;;AAMA;EACE,eAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAHF;;AAOA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAJF;AAME;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;AAJJ;AAOE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AALJ;AAOI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sCAAA;AALN;AAOM;EACE,yBAAA;AALR;AAQM;EACE,SAAA;EACA,eAAA;EACA,kCAAA;AANR;AASM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAPR;AAUM;EACE,cAAA;EACA,gBAAA;AARR;;AAeA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAZF;AAcE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;AAZJ;AAeE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAbJ;AAeI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sCAAA;AAbN;AAeM;EACE,yBAAA;AAbR;AAgBM;EACE,SAAA;EACA,eAAA;EACA,kCAAA;AAdR;AAiBM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAfR;AAkBM;EACE,cAAA;EACA,gBAAA;AAhBR;;AAsBA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AAnBF;AAqBE;EACE,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAnBJ;AAqBI;EACE,yBAAA;AAnBN;AAuBE;EACE,iBAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AArBJ;AAuBI;EACE,sBAAA;EACA,mBAAA;AArBN;AAwBI;EACE,YAAA;AAtBN","sourcesContent":[".export-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.export-modal {\n  background: white;\n  border-radius: 8px;\n  padding: 24px;\n  width: 90%;\n  max-width: 450px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n}\n\n.export-modal-title {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 16px;\n  text-align: center;\n  color: #333;\n}\n\n.export-modal-options {\n  margin-bottom: 20px;\n\n  .export-modal-range {\n    margin-left: 24px;\n    display: flex;\n    gap: 8px;\n    margin-top: 8px;\n\n    input[type=\"date\"] {\n      padding: 4px;\n      border: 1px solid #ccc;\n      border-radius: 4px;\n    }\n\n    span {\n      align-self: center;\n      font-weight: bold;\n    }\n  }\n}\n\n.export-modal-option {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 8px;\n\n  input {\n    width: 16px;\n    height: 16px;\n    accent-color: var(--primary-color);\n    margin-right: 8px;\n  }\n}\n\n.export-modal-desc {\n  font-size: 14px;\n  color: #666;\n  margin-left: 24px;\n  line-height: 1.4;\n  margin-top: 8px;\n  margin-bottom: 12px;\n}\n\n// Content Type Selection Styles\n.export-modal-content-type {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding: 15px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background-color: #f8f9fa;\n\n  .content-type-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #2c3e50;\n    margin-bottom: 12px;\n    margin-top: 0;\n  }\n\n  .content-type-options {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    .content-type-option {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      cursor: pointer;\n      padding: 8px 12px;\n      border-radius: 6px;\n      transition: background-color 0.2s ease;\n\n      &:hover {\n        background-color: #e9ecef;\n      }\n\n      input[type=\"radio\"] {\n        margin: 0;\n        cursor: pointer;\n        accent-color: var(--primary-color);\n      }\n\n      span {\n        font-size: 13px;\n        color: #4a5568;\n        font-weight: 500;\n        cursor: pointer;\n      }\n\n      input[type=\"radio\"]:checked + span {\n        color: #0a3d62;\n        font-weight: 600;\n      }\n    }\n  }\n}\n\n// Orientation Selection Styles\n.export-modal-orientation {\n  margin-top: 20px;\n  padding: 15px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background-color: #f8f9fa;\n\n  .orientation-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #2c3e50;\n    margin-bottom: 12px;\n    margin-top: 0;\n  }\n\n  .orientation-options {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n\n    .orientation-option {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      cursor: pointer;\n      padding: 8px 12px;\n      border-radius: 6px;\n      transition: background-color 0.2s ease;\n\n      &:hover {\n        background-color: #e9ecef;\n      }\n\n      input[type=\"radio\"] {\n        margin: 0;\n        cursor: pointer;\n        accent-color: var(--primary-color);\n      }\n\n      span {\n        font-size: 13px;\n        color: #4a5568;\n        font-weight: 500;\n        cursor: pointer;\n      }\n\n      input[type=\"radio\"]:checked + span {\n        color: #0a3d62;\n        font-weight: 600;\n      }\n    }\n  }\n}\n\n.export-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 25px;\n\n  .btn-cancel {\n    padding: 8px 16px;\n    border: 1px solid #ddd;\n    background: white;\n    color: #666;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n\n    &:hover {\n      background-color: #f8f9fa;\n    }\n  }\n\n  .btn-export {\n    padding: 8px 16px;\n    background: var(--primary-color);\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n\n    &:disabled {\n      background-color: #ccc;\n      cursor: not-allowed;\n    }\n\n    &:not(:disabled):hover {\n      opacity: 0.9;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
